import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/"
)({
  beforeLoad: async () => {
    throw redirect({to: "profile" as string});
  },
  component: RouteComponent,
});

function RouteComponent() {
  return null;
}
